import { Languages } from 'lucide-react';

import { useLocale } from '../hooks';
import { Button } from './ui';

export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();

  const toggleLocale = () => {
    setLocale(locale === 'en' ? 'uk' : 'en');
  };

  return (
    <Button variant="ghost" size="sm" onClick={toggleLocale} className="gap-2">
      <Languages className="h-4 w-4" />
      {locale === 'en' ? 'Eng' : 'Укр'}
    </Button>
  );
}
